import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const namespaced = true

const state = {
  data: {},
  fetching: false,
  chromeless: false
}

export default {
  namespaced,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/config/index.js